<ng-container *ngFor="let formField of activeFormFields">
    <ng-container [formFieldKey]="formField.field" [searchFormFieldTemplateLoader]="formField.template"></ng-container>
</ng-container>
